import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, Subject, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagesService {
  constructor(private http: HttpClient,) { }

  post2(payload: any, url: string): Observable<any> {

    return this.http.post<any>(url, payload).pipe(
      catchError(err => {
        console.log(err?.error?.msg)
        return of(err?.error);
      }),
      map(resp => resp),
    )
  }

  post(payload: any, url: string): Observable<any> {

    return this.http.post<any>(url, payload).pipe(
      catchError(err => {
        console.log(err?.error?.msg)
        return of(err?.error?.msg);
      }),
      map(resp => resp),
    )
  }

  put(payload: any, url: string): Observable<any> {

    return this.http.put<any>(url, payload).pipe(
      catchError(err => {
        console.log(err)
        return err
      }),
      map(resp => resp),
    )
  }

  get(payload: any, url: any): Observable<any> {
    let params = new HttpParams()
    params = params.appendAll(payload)
    return this.http.get(url, { params: params }).pipe(
      catchError(err => {
        // console.log(err,"error")

        return throwError(err);
      }),
      map((response: any) => {
        return response;
      }),

    )
  }

  delete(path: string, id: any, id2?: any, id3?: any): Observable<any> {
    return this.http.delete(`${path + '/' + id + (id2 ? '/' + id2 : '') + (id3 ? '/' + id3 : '')}`,).pipe(
      catchError((err: any) => {
        console.log(err)
        return err
      }),
      map((resp: any) => resp),
    );
  }

  deleteWithParams(path: string, data: any): Observable<any> {
    let params = new HttpParams()
    params = params.appendAll(data)
    return this.http.delete(`${path}`, { params: params }).pipe(
      catchError((err: any) => {
        return of(err?.error);
      }),
      map((resp: any) => resp),
    );
  }
  patch(path: string, body: Object = {}): Observable<any> {
    return this.http.patch(`${path}`, JSON.stringify(body)).pipe(catchError(this.formatErrors));
  }
  private formatErrors(error: any) {
    return throwError(() => error.error);
  }

  postFile(path: string, file: File): Observable<any> {

    const formData: FormData = new FormData();
    formData.append('file', file);
    console.log(formData, file)
    return this.http.post(`${path}`, formData).pipe(catchError(this.formatErrors));
  }
}
